import React, { useEffect } from "react";
import privacypolicyImg from "../assets/WebImage/privacypolicy.jpg";

function PrivacyPolicy() {
  const today = new Date();

  useEffect(() => {
    document.title = "Free Credit - Privacy Policy";
  }, []);

  return (
    <>
      <div className="card m-2">
        <div style={{ textAlign: "justify" }}>
          {" "}
          <div>
            <img
              style={{ maxWidth: "100%", height: "auto", display: "block" }}
              loading="lazy"
              src={privacypolicyImg}
              alt="Privacy Policy-Jom Free Credit Malaysia - freekredit freecredit linkfreekredit linkfreecredit megafreecredit
      megafreekredit"
            />
          </div>
          <div className="p-3">
            <h1>Privacy Policy</h1>
            <strong>Published On: </strong>1 April 2026
            <br />
            <strong>Last Updated: </strong>
            {today.toLocaleDateString("en-MY", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
            <br />
            <br />
            <p>
              At JomFreeCredit.online, we respect your privacy and are committed
              to protecting any information collected through our website.
            </p>
            <p>
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you visit our platform.
            </p>
            <p>
              By using our website, you agree to the practices described in this
              policy.
            </p>
            <hr />
            <h2>Information We Collect</h2>
            <p>We may collect limited types of information, including:</p>
            <ul>
              <li>
                <strong>Non-Personal Data:</strong> Browser type, device
                information, IP address, pages visited, and usage patterns
              </li>
              <li>
                <strong>Voluntary Information:</strong> Any information you
                provide through contact forms or email communication
              </li>
            </ul>
            <p>
              We do not require user account registration and do not collect
              sensitive personal or financial information directly.
            </p>
            <hr />
            <h2>How We Use Information</h2>
            <p>Information collected may be used to:</p>
            <ul>
              <li>Improve website functionality and user experience</li>
              <li>Analyze traffic patterns and usage trends</li>
              <li>Respond to inquiries or feedback</li>
              <li>Maintain platform security and performance</li>
            </ul>
            <p>
              We do not sell, rent, or trade personal information to third
              parties.
            </p>
            <hr />
            <h2>Cookies & Tracking Technologies</h2>
            <p>
              Our website may use cookies and similar tracking technologies to
              enhance user experience and analyze site performance.
            </p>
            <p>Cookies may be used to:</p>
            <ul>
              <li>Remember user preferences</li>
              <li>Understand visitor behavior</li>
              <li>Measure traffic and engagement</li>
            </ul>
            <p>
              You can choose to disable cookies through your browser settings.
              However, some parts of the website may not function properly as a
              result.
            </p>
            <hr />
            <h2>Third-Party Links</h2>
            <p>
              Our platform may contain links to third-party websites, including
              partner platforms and external services.
            </p>
            <p>
              We are not responsible for the privacy practices, content, or
              policies of these external websites. Users are encouraged to
              review their respective privacy policies before providing any
              information.
            </p>
            <hr />
            <h2>Affiliate Disclosure</h2>
            <p>
              JomFreeCredit.online participates in affiliate marketing programs.
              This means we may earn commissions when users click on certain
              links or register with partner platforms.
            </p>
            <p>
              These partnerships do not affect how information is collected or
              handled on our platform.
            </p>
            <hr />
            <h2>Data Security</h2>
            <p>
              We implement reasonable technical and organizational measures to
              protect information against unauthorized access, alteration,
              disclosure, or destruction.
            </p>
            <p>
              However, no method of transmission over the internet is completely
              secure, and we cannot guarantee absolute security.
            </p>
            <hr />
            <h2>Data Retention</h2>
            <p>
              We retain collected information only for as long as necessary to
              fulfill the purposes outlined in this policy, unless a longer
              retention period is required or permitted by law.
            </p>
            <hr />
            <h2>User Rights</h2>
            <p>
              Depending on applicable laws and regulations, users may have the
              right to:
            </p>
            <ul>
              <li>Request access to their data</li>
              <li>Request correction or deletion of data</li>
              <li>Withdraw consent where applicable</li>
            </ul>
            <p>Requests can be made through our official contact channels.</p>
            <hr />
            <h2>Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time to reflect
              changes in legal, technical, or operational requirements.
            </p>
            <p>
              Any updates will be reflected by the “Last Updated” date at the
              top of this page.
            </p>
            <hr />
            <h2>Contact Information</h2>
            <p>
              If you have any questions or concerns regarding this Privacy
              Policy, you may contact us through the communication channels
              provided on our website.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
